import CustomDropdown from '../../components/CustomDropdown';
import React, { Component } from "react";
import { FormHelperText, Input, FormControl, Popover, Divider, Button, IconButton, Icon, Paper, Card, DialogContent, Dialog, DialogActions, DialogTitle, Typography, MenuItem, InputLabel, Radio, FormControlLabel, RadioGroup, Badge, Drawer, Tooltip, Avatar } from "@material-ui/core";
import Grid, { default as MaterialGrid } from '@material-ui/core/Grid';
// import ReportSidebarMenu from "../Layout/ReportSidebarMenu";
import Select from '@material-ui/core/Select';
import FilterListIcon from '@material-ui/icons/FilterList';

import { DateRangePicker, DateRange } from "materialui-daterange-picker";
import CreateIcon from '@material-ui/icons/Create';
import moment from 'moment';//moment
import 'moment-timezone';//timezone
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import HttpsIcon from '@material-ui/icons/Https';

import { Link } from "react-router-dom";
import * as actions from '../../store/actions/index';
import { connect } from "react-redux";

class SalesPerformanceSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateopen: false,
            dateformat: 'MM/DD/YYYY',
            selectedDate: { from: moment().startOf("month").format('YYYY-MM-DD'), to: moment().endOf('month').format('YYYY-MM-DD') },
            selectedDatelabel: "",
            selectedDateid: "4",
            definedRanges: [
                {
                    id: 3,
                    label: "This Week",
                    startDate: moment().day(1).format('YYYY-MM-DD'),
                    endDate: moment().day(7).format('YYYY-MM-DD')
                },

                {
                    id: 4,
                    label: "This Month",
                    startDate: moment().startOf("month").format('YYYY-MM-DD'),
                    endDate: moment().endOf("month").format('YYYY-MM-DD')
                },

                {
                    id: 5,
                    label: "This Quarter",
                    startDate: moment().startOf('quarter').format('YYYY-MM-DD'),
                    endDate: moment().endOf('quarter').format('YYYY-MM-DD')
                },

                {
                    id: 6,
                    label: "This Year",
                    startDate: moment().startOf('year').format('YYYY-MM-DD'),
                    endDate: moment().endOf('year').format('YYYY-MM-DD')
                },

                {
                    id: 7,
                    label: "Last 7 days",
                    startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                },

                {
                    id: 8,
                    label: "Last 30 days",
                    startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                },
                {
                    id: 9,
                    label: "All Time",
                    startDate: "",
                    endDate: ""
                },
            ],
            fromdate: moment().startOf("month").format('YYYY-MM-DD'),
            todate: moment().endOf("month").format('YYYY-MM-DD'),
            timeno: 4,
            selectedPipline: "1",
            value_type: "1",
            datetype: 3,
            memberid: 0
        }
    }
    componentDidMount() {
        localStorage.setItem('dashboardFromDate', this.state.fromdate);
        localStorage.setItem('dashboardToDate', this.state.todate);
        localStorage.setItem('dashboardTimeNo', this.state.timeno);
    }
    componentWillReceiveProps(props) {
        if (props.settingReducer.userSettingArray && props.settingReducer.userSettingArray.data) {
            let usersetting = props.settingReducer.userSettingArray.data;
            this.setState({ dateformat: usersetting.dateformat, timeZone: usersetting.timezone })
        }
        if (props.reportReducer.UserDashboardId) {
            if (this.state.memberid !== props.reportReducer.UserDashboardId) {
              {
                this.setState({
                  memberid: props.reportReducer.UserDashboardId
                }, () => this.forceUpdate())
              }
            }
          }
    }

    handleDateRangeChange = (event) => {
        let daterangekey = this.findWithAttr(this.state.definedRanges, 'id', event.target.value);
        if (daterangekey != -1) {
            this.setState({
                selectedDateid: event.target.value.toString(),
                fromdate: this.state.definedRanges[daterangekey].startDate,
                todate: this.state.definedRanges[daterangekey].endDate
            })
        }
        localStorage.setItem('dashboardFromDate', this.state.definedRanges[daterangekey].startDate);
        localStorage.setItem('dashboardToDate', this.state.definedRanges[daterangekey].endDate);
        localStorage.setItem('dashboardTimeNo', parseInt(this.state.definedRanges[daterangekey].id));

        let fromDate = this.state.definedRanges[daterangekey].startDate;
        let toDate = this.state.definedRanges[daterangekey].endDate;

        let piplineparams = {
            filterdata: [],
            piplineid: parseFloat(this.state.selectedPipline),
            type: parseFloat(this.state.value_type),
            fromdate: fromDate,
            todate: toDate,
            memberid: parseFloat(this.state.memberid)
        };
        this.props.piplineSummary(this.props.apolloClient.client, piplineparams);


        let forecastparams = {
            filterdata: [],
            piplineid: parseFloat(this.state.selectedPipline),

            type: parseFloat(this.state.value_type),
            fromdate: fromDate,
            todate: toDate,
            datetype: parseFloat(this.state.datetype),
            memberid: parseFloat(this.state.memberid)
        };
        this.props.salesForecastSummary(this.props.apolloClient.client, forecastparams);

        let performanceparams = {
            filterdata: [],
            piplineid: parseFloat(this.state.selectedPipline),
            type: parseFloat(this.state.value_type),
            fromdate: fromDate,
            todate: toDate,
            datetype: parseFloat(this.state.datetype),
            memberid: parseFloat(this.state.memberid)
        };
        this.props.salesPerformance(this.props.apolloClient.client, performanceparams);

        let performancesummaryparams = {
            filterdata: [],
            piplineid: parseFloat(this.state.selectedPipline),
            type: parseFloat(this.state.value_type),
            fromdate: fromDate,
            todate: toDate,
            datetype: parseFloat(this.state.datetype),
            timeno: parseInt(this.state.definedRanges[daterangekey].id),
            memberid: parseFloat(this.state.memberid),
        };
        this.props.salesPerformanceSummary(this.props.apolloClient.client, performancesummaryparams);

        let params = {
            filterdata: [],
            piplineid: parseFloat(this.state.selectedPipline),
            type: parseFloat(this.state.value_type),
            fromdate: fromDate,
            todate: toDate,
            memberid: parseFloat(this.state.memberid)
        };

        this.props.salesBySourceReport(this.props.apolloClient.client, params);
    }

    findWithAttr = (array, attr, value) => {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] == value) {
                return i;
            }
        }
        return -1;
    }

    setDateRange = (range) => {
        let startDate = moment(range.startDate).format('YYYY-MM-DD');
        let endDate = moment(range.endDate).format('YYYY-MM-DD');

        let activityparams = {
            fromdate: startDate,
            todate: endDate,
            memberid: parseFloat(this.state.memberid)
        };
        this.props.activityLeaderboard(this.props.apolloClient.client, activityparams);

        if (range.label) {
            this.setState({ selectedDatelabel: range.label });
        } else {
            this.setState({ selectedDate: { from: startDate, to: endDate }, selectedDatelabel: "" });
        }

        this.setState({ fromdate: startDate, todate: endDate })
    }



    render() {
        let { definedRanges, selectedDateid, dateopen, fromdate, todate } = this.state;

        const cardStyle = {
            background: "linear-gradient(135deg, #ffffff 0%, #f0f7ff 100%)",
            borderRadius: "16px",
            border: "1px solid rgba(2, 136, 209, 0.1)",
            boxShadow: "0 4px 20px rgba(31, 38, 135, 0.07)",
            padding: "16px 24px",
            marginBottom: "24px"
        };

        const selectedRange = definedRanges.find(r => r.id.toString() === selectedDateid.toString());
        const selectedLabel = selectedRange ? selectedRange.label : "This Month";

        return (
            <Card elevation={0} style={cardStyle}>
                <Grid container direction="row" justify="space-between" alignItems="center" spacing={2}>

                    {/* Left: Title + Date range text */}
                    <Grid item xs={12} sm="auto">
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <div style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                                background: "linear-gradient(135deg, #0288D1, #26C6DA)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 4px 10px rgba(2, 136, 209, 0.3)",
                                flexShrink: 0,
                            }}>
                                <Icon style={{ color: "#fff", fontSize: "1.2rem" }}>date_range</Icon>
                            </div>
                            <div>
                                <div style={{
                                    fontSize: "0.72rem",
                                    fontWeight: 600,
                                    color: "#90a4ae",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.08em",
                                    marginBottom: "2px"
                                }}>
                                    Dashboard Period
                                </div>
                                <div style={{
                                    fontSize: "0.95rem",
                                    fontWeight: 700,
                                    color: "#263238",
                                    fontFamily: "'Inter', sans-serif",
                                }}>
                                    {fromdate === "" && todate === ""
                                        ? "All Time"
                                        : `${fromdate}  →  ${todate}`
                                    }
                                </div>
                            </div>
                        </div>
                    </Grid>

                    {/* Right: Quick range chips + dropdown */}
                    <Grid item xs={12} sm="auto">
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>

                            {/* Quick select chips for common ranges */}
                            {["This Week", "This Month", "This Quarter", "This Year"].map((label) => {
                                const range = definedRanges.find(r => r.label === label);
                                if (!range) return null;
                                const isActive = selectedDateid.toString() === range.id.toString();
                                return (
                                    <button
                                        key={range.id}
                                        onClick={() => this.handleDateRangeChange({ target: { value: range.id } })}
                                        style={{
                                            padding: "6px 14px",
                                            borderRadius: "20px",
                                            border: isActive
                                                ? "1.5px solid #0288D1"
                                                : "1.5px solid rgba(0,0,0,0.1)",
                                            background: isActive
                                                ? "linear-gradient(135deg, #0288D1, #26C6DA)"
                                                : "rgba(255,255,255,0.8)",
                                            color: isActive ? "#fff" : "#546e7a",
                                            fontSize: "0.78rem",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                            fontFamily: "'Inter', sans-serif",
                                            transition: "all 0.2s ease",
                                            boxShadow: isActive ? "0 3px 8px rgba(2, 136, 209, 0.3)" : "none",
                                            outline: "none",
                                        }}
                                        onMouseOver={(e) => { if (!isActive) e.currentTarget.style.borderColor = "#0288D1"; if (!isActive) e.currentTarget.style.color = "#0288D1"; }}
                                        onMouseOut={(e) => { if (!isActive) e.currentTarget.style.borderColor = "rgba(0,0,0,0.1)"; if (!isActive) e.currentTarget.style.color = "#546e7a"; }}
                                    >
                                        {label}
                                    </button>
                                );
                            })}

                            {/* More options dropdown */}
                            <Select
                                value={selectedDateid}
                                onChange={this.handleDateRangeChange}
                                disableUnderline
                                inputProps={{ name: 'selectedDateid' }}
                                MenuProps={{
                                    anchorOrigin: { vertical: "bottom", horizontal: "right" },
                                    transformOrigin: { vertical: "top", horizontal: "right" },
                                    getContentAnchorEl: null,
                                }}
                                style={{
                                    padding: "4px 8px",
                                    borderRadius: "20px",
                                    border: "1.5px solid rgba(0,0,0,0.1)",
                                    background: "rgba(255,255,255,0.9)",
                                    fontWeight: 600,
                                    color: "#546e7a",
                                    fontSize: "0.78rem",
                                    fontFamily: "'Inter', sans-serif",
                                    minWidth: "100px",
                                    height: "32px",
                                    paddingRight: "28px",
                                }}
                            >
                                {definedRanges && definedRanges.map((range, i) => (
                                    <MenuItem key={i} value={range.id} style={{ fontWeight: 500, fontSize: "0.85rem" }}>
                                        {range.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                    </Grid>
                </Grid>
            </Card>
        );
    }
}

const mapStateToProps = state => ({
    settingReducer: state.settingReducer,
    apolloClient: state.apolloClient,
    notification: state.notification,
    reportReducer: state.reportReducer,
});
const mapDispatchToProps = dispatch => {
    return {

        piplineSummary: (client, value) => dispatch(actions.piplineSummary(client, value)),
        salesForecastSummary: (client, value) => dispatch(actions.salesForecastSummary(client, value)),
        salesPerformance: (client, value) => dispatch(actions.salesPerformance(client, value)),
        salesPerformanceSummary: (client, value) => dispatch(actions.salesPerformanceSummary(client, value)),
        salesBySourceReport: (client, value) => dispatch(actions.salesBySourceReport(client, value)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SalesPerformanceSummary);